<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <transition name="fade">
          <b-card
            border-variant="info"
            header-bg-variant="primary"
            header-text-variant="white"
          >
            <component-new-header
              title="Inventory"
              :hasSearch="false"
              :hasReload="false"
              :hasRadio="false"
              :hasCreate="true"
              :hasback="false"
              createButtonText="Help"
              @create-press="$router.push({ path: '/faqdetails' })"
            />

            <b-tabs v-model="tabIndex">
              <b-tab title="Select Delivery Centre">
                <inventory-report></inventory-report>
              </b-tab>
              <b-tab title="Item Details">
                <item-details></item-details>
              </b-tab>
              <b-tab title="Load Inventory">
                <loadinventory></loadinventory>
              </b-tab>
              <b-tab title="Update Inventory">
                <updateinventory></updateinventory>
              </b-tab>
              <b-tab title="Transfer Inventory">
                <transferinventory></transferinventory>
              </b-tab>
              <b-tab title="Upload History" :title-item-class="'uploadHistory'">
                <inventoryResults></inventoryResults>
              </b-tab>
            </b-tabs>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ItemDetails from "@/views/inventory/ItemDetails.vue";
import loadinventory from "@/views/inventory/LoadInventory.vue";
import updateinventory from "@/views/inventory/UpdateInventory.vue";
import transferinventory from "@/views/inventory/TransferInventory.vue";
import inventoryResults from "@/views/inventory/InventoryUpdateHistory.vue";
import InventoryReport from "@/views/inventory/InventoryReport.vue";
import componentNewHeader from "@/components/componentNewHeader";
export default {
  name: "Inventory",
  components: {
    "item-details": ItemDetails,
    loadinventory,
    updateinventory,
    transferinventory,
    inventoryResults,
    componentNewHeader,
    "inventory-report": InventoryReport,
  },
  data: () => {
    return {
      tabIndex: 0,
    };
  },
  methods: {
    ...mapActions({
      GetStockpoints: "partner/fetchStockpointsByTenant",
    }),
  },
  mounted: async function () {
    this.GetStockpoints();
  },
};
</script>

